var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCarrotLeft = function SvgCarrotLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.143 6.55c.41.41.41 1.075 0 1.485l-4.158 4.158 4.158 4.157a1.05 1.05 0 01-1.486 1.485l-4.9-4.9a1.05 1.05 0 010-1.485l4.9-4.9a1.05 1.05 0 011.486 0z",
    fill: "#9CA6AD"
  })));
};

export default SvgCarrotLeft;